/*
  Login.jsx
  ----------------
  Interface de connexion à la plateforme.
*/
import { useState } from "react";
import { Button, Card, Center, TextInput, PasswordInput, Group, Anchor, Modal } from "@mantine/core";
import { useUser } from "../tools/Context";
import { showNotification } from "@mantine/notifications";
import { post } from "../tools/Request";
import { useDisclosure } from "@mantine/hooks";
import { useNavigate } from "react-router-dom";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const { setUserData } = useUser();
  const [opened, { open, close }] = useDisclosure(false);
  const [forgotEmail, setForgotEmail] = useState("");
  const navigate = useNavigate();
  const handleLogin = async () => {
    try {
      const response = await post("login", { email, password });
      setUserData(response.id, response.token, response.role, response.email, response.isratp);
      showNotification({ title: "Vous êtes désormais connecté", autoClose: 3000, color: "teal" });
      navigate("/");
    } catch (err) {
      console.log(err);
      showNotification({
        title: "Une erreur est survenue",
        message: err.error,
        autoClose: 3000,
        color: "red",
      });
    }
  };

  const handleForgot = async () => {
    try {
      await post("password/forgot", { email: forgotEmail });
      showNotification({
        title: "Si un compte existe, un email a été envoyé.",
        autoClose: 4000,
        color: "teal",
      });
      close();
    } catch (err) {
      showNotification({ title: "Impossible d'envoyer la demande", autoClose: 3000, color: "red" });
    }
  };

  return (
    <>
      <Center mt="18%">
        <Card shadow="sm" padding="lg" radius="md" withBorder>
          <TextInput placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} />
          <PasswordInput
            placeholder="Mot de passe"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            mt="md"
          />
          <Group justify="space-between" mt="xs">
            <Anchor size="sm" onClick={open}>
              Mot de passe oublié ?
            </Anchor>
          </Group>
          <Button mt={10} onClick={handleLogin}>
            Connexion
          </Button>
        </Card>
      </Center>

      <Modal opened={opened} onClose={close} title="Réinitialiser le mot de passe" centered>
        <TextInput
          label="Votre email"
          placeholder="nom@exemple.com"
          value={forgotEmail}
          onChange={(e) => setForgotEmail(e.target.value)}
        />
        <Button mt="md" onClick={handleForgot}>
          Envoyer le lien de réinitialisation
        </Button>
      </Modal>
    </>
  );
}
